module.exports = __webpack_public_path__ + "img/tpc-12.1ee6f679.webp";